export const EMAIL_PATTERN = new RegExp(/^[^\s@]+@[^\s@0-9]+\.[^\s@0-9]+$/);
export const TELEPHONE_PATTERN = new RegExp(/^\d{10}$/);



// WEBPACK FOOTER //
// ./src/utils/pattern.util.js